export function getFormFields(form: HTMLFormElement): Record<string, string | undefined> {
	const formData = new FormData(form);
	const fields: Record<string, string | undefined> = {};
	for (const [key, value] of formData.entries()) {
		// We handle files on our own/separately.
		if (typeof value !== "string") {
			continue;
		}
		fields[key] = value === "" ? undefined : value;
	}
	return fields;
}
